/**
 * Returns the base url of the app
 */
function getBaseUrl() {
  const {
    REACT_APP_URL_SCHEME,
    REACT_APP_URL_DEFAULT_SUBDOMAIN,
    REACT_APP_URL_DOMAIN
  } = process.env;

  return `${REACT_APP_URL_SCHEME}${REACT_APP_URL_DEFAULT_SUBDOMAIN}.${REACT_APP_URL_DOMAIN}`;
}

export default getBaseUrl;
